// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/engagement/whatsapp/account_data" endpoint
 */
import { isIntegrationsGetWhatsAppDataResult } from "@dashboardApi/apis/integrationsGetWhatsAppData/validators";

import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { integrationsGetWhatsAppData } from "./constants";
import type { IntegrationsGetWhatsAppDataParams, IntegrationsGetWhatsAppDataResult } from "./types";

export const getDataTableIntegrationsGetWhatsAppData = reactQueryTableFetcherAdapter(
  integrationsGetWhatsAppData,
  (
    signal: AbortSignal,
    { appGroupId, wabaEId, query, groupby, limit, start = 0, sortdir, sortby }: IntegrationsGetWhatsAppDataParams
  ): Promise<IntegrationsGetWhatsAppDataResult> => {
    return fetch(
      "/engagement/whatsapp/account_data",
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        external_id: wabaEId,
        query: serializeQueryObjects(query),
      },
      { signal }
    );
  },
  isIntegrationsGetWhatsAppDataResult
);
